// typed, explicit env exposure for shared; must be the first import in main
declare global {
   
  var __ORREKIE_ENV__: Record<string, string | boolean | undefined> | undefined;
}
globalThis.__ORREKIE_ENV__ = import.meta.env as Record<string, string | boolean | undefined>;
export {};
